export const environment = {
  production: false,
  apiUrl: 'https://test.medilink.com.ec:3000/graphql/',
  imgUrl: 'https://test.medilink.com.ec:3000/',
  apiUploadImage: 'https://web.medilink.com.ec:8443/uploads/uploadImage',
  apiUploadDocuments: 'http://192.168.1.2:8089/xml/comprasOrdenes/uploadDocument',
  apiGetDataOfOrden: 'http://192.168.1.2:8089/xml/comprasOrdenes/checkExistence',
  apiGetDataOfProveedor: 'http://192.168.1.2:8089/xml/proveedores/dataOfProveedor',
  apiCheckUrl: 'http://192.168.1.2:8089/xml/comprasOrdenes/validateLink',
  apiSendPQRS: 'https://test.medilink.com.ec:3000/send-email/pqrs'
};
